import {type FC, type ReactNode, useCallback, useEffect} from 'react';
import Backdrop from './Backdrop.tsx';
import useGlobalStore from '../../store/useGlobalStore.ts';
import useModal from '../../hooks/useModal.tsx';

export interface ModalComponentProps {
    isOpen: boolean;
    children: ReactNode;
    isTopmost?: boolean;
    itemId: string;
}

const Modal: FC<ModalComponentProps> = ({isOpen, children, isTopmost = true, itemId}) => {
    const {stack} = useGlobalStore();
    const {close} = useModal();

    const onClose = useCallback(() => {
        close(itemId);
    }, []);

    useEffect(() => {
        if (!isOpen) return;
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && onClose && isTopmost) {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose, isTopmost]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <Backdrop
            isOpen={stack.some((item) => item.id === itemId)}
            onClose={onClose}
            animation={'fade'}
            isTopmost={isTopmost}
        >
            {children}
        </Backdrop>
    );
};

export default Modal;
